module.exports = __webpack_public_path__ + "static/media/2.767ba7e8.png";